function Q1OperatingResults2025() {
	return (
		<div className="not-prose">
			<div className="overflow-x-auto">
				<table className="min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<thead>
						<tr>
							<th colSpan={5}>
								<span className="block mb-2 text-right text-[0.75rem] text-black">($ in billions)</span>
							</th>
						</tr>
						<tr className="text-center no-hover text-[#4B7B9D] leading-[140%] ">
							<td></td>
							<th colSpan={3} className="align-bottom border-none">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none">Commercial Lines Business</th>
						</tr>
						<tr className="text-right no-hover text-[#4B7B9D]">
							<td></td>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Vehicles</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Property</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Total</th>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Written</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="no-hover">Six Months Ended June 30,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>
								<span className="float-left">$</span>34.4
							</td>
							<td>
								<span className="float-left">$</span>1.6
							</td>
							<td>
								<span className="float-left">$</span>36.0
							</td>
							<td>
								<span className="float-left">$</span>6.3
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>29.0</td>
							<td>1.6</td>
							<td>30.6</td>
							<td>6.3</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>18%</td>
							<td>1%</td>
							<td>18%</td>
							<td>1%</td>
						</tr>

						<tr>
							<td colSpan={5} className="py-4"></td>
						</tr>

						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Earned</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="no-hover">Six Months Ended June 30,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>
								<span className="float-left">$</span>32.7
							</td>
							<td>
								<span className="float-left">$</span>1.6
							</td>
							<td>
								<span className="float-left">$</span>34.3
							</td>
							<td>
								<span className="float-left">$</span>5.5
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>26.7</td>
							<td>1.4</td>
							<td>28.1</td>
							<td>5.2</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>23%</td>
							<td>7%</td>
							<td>22%</td>
							<td>5%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						<tr>
							<th className="font-bold font-trade text-[#767727] no-hover">Policies in Force</th>
							<th></th>
							<th></th>
							<th></th>
							<th className="text-[0.75rem] font-trade !pr-0 !border-r-0">
								<span className="block mb-2 text-[0.75rem] text-right text-black">(# in thousands)</span>
							</th>
						</tr>
						<tr>
							<td className="no-hover">June 30,</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2025</td>
							<td>32,518</td>
							<td>3,608</td>
							<td>36,126</td>
							<td>1,189</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>27,853</td>
							<td>3,339</td>
							<td>31,192</td>
							<td>1,118</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Growth over prior period</td>
							<td>17%</td>
							<td>8%</td>
							<td>16%</td>
							<td>6%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						{/* <tr className="no-hover text-center no-hover text-[#4B7B9D] leading-[140%] ">
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<th className="align-bottom border-none">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none">Commercial Lines Business</th>
						</tr> */}
						<tr>
							<td className="font-bold font-trade text-[#767727] ">Underwriting Ratios</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<th className="align-bottom border-none text-center no-hover text-[#4B7B9D] leading-[140%]">
								Personal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none text-center no-hover text-[#4B7B9D] leading-[140%]">Commercial Lines Business</th>
						</tr>
						<tr>
							<td className="no-hover">Six Months Ended June 30,</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
						</tr>
						<tr>
							<td className="cell-indent" colSpan={2}>
								Loss and loss adjustment expense ratio – 2025
							</td>

							<td className="!border-r-0"></td>
							<td>66.2</td>
							<td>67.2</td>
						</tr>
						<tr>
							<td className="cell-indent" colSpan={2}>
								Underwriting expense ratio – 2025
							</td>
							<td className="!border-r-0"></td>

							<td className="border-b-[1px] border-[#BFBFBF]">19.7</td>
							<td className="border-b-[1px] border-[#BFBFBF]">19.9</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Combined ratio – 2025</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td>85.9</td>
							<td>87.1</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Combined ratio – 2024</td>
							<td className="!border-r-0"></td>
							<td className="!border-r-0"></td>
							<td>88.9</td>
							<td>90.2</td>
						</tr>
						<tr>
							<td className="cell-indent--3" colSpan={2}>
								Change over prior period
							</td>
							<td className="!border-r-0"></td>
							<td>(3.0) pts.</td>
							<td>(3.1) pts.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default Q1OperatingResults2025;
